export function getFilteredByPricesFlights(flightsOnLeg, selectedFlights, prices) {
    if (!flightsOnLeg.length) {
        return [];
    }
    const lastSelectedFlight = selectedFlights[selectedFlights.length - 1];
    const pricesMap = new Map(prices.map(price => [price.flightId, price]));
    return flightsOnLeg
        .filter(flight => flight.pricesForFareGroups.some(fareGroup => {
        if (!fareGroup.prices) {
            return false;
        }
        if (lastSelectedFlight) {
            const priceIdsSet = new Set(lastSelectedFlight.prices.map(price => price.flight.id));
            return fareGroup.prices.some(price => priceIdsSet.has(price.flight.id));
        }
        return true;
    }))
        .map(flight => (Object.assign(Object.assign({}, flight), { pricesForFareGroups: flight.pricesForFareGroups.map(fareGroup => (Object.assign(Object.assign({}, fareGroup), { prices: (fareGroup.prices || []).map(price => {
                var _a, _b;
                return (Object.assign(Object.assign({}, price), { price: (_b = (_a = pricesMap.get(price.flight.id)) === null || _a === void 0 ? void 0 : _a.priceToPay) !== null && _b !== void 0 ? _b : null }));
            }) }))) })));
}
